import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import i18next from 'i18next';
import axios from 'axios';
import { useCookieConsent } from '../../context/CookieConsentContext';

const PageViewTracker = () => {
  const location = useLocation();
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    const trackPageView = async () => {
      // Only track page views if user has given consent
      if (hasConsent !== true) {
        return;
      }
      
      try {
        // Get current language
        const language = i18next.language || 'sv';

        // Track the page view using the correct environment variable
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/track-page-view`, {
          path: location.pathname,
          language,
          title: document.title // Include the page title
        });
      } catch (error) {
        console.error('Error tracking page view:', error);
      }
    };

    trackPageView();
  }, [location.pathname, hasConsent]); // Re-run when pathname or consent status changes

  return null; // This component doesn't render anything
};

export default PageViewTracker; 